import { FormSecretariaComponent } from './../secretaria/form-secretaria/form-secretaria.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {path: "dados/:id", component: FormSecretariaComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class SecretariaRoutingModule { }
